<sirius-grid>
    <div class="sir-content">
        <sirius-heading [text]="title" textStyleCategory="title" textStyleSize="m"></sirius-heading>
        <div class="sir-text">
            <sirius-text-html [html]="textHtml" textStyleSize="m"></sirius-text-html>
        </div>
    </div>
    <div class="sir-highlight">
        <div class="sir-highlight-content">
            <sirius-heading [text]="highlightTitle" [h]="3" textStyleSize="xs"></sirius-heading>
            @if (highlightText) {
                <sirius-text-html [html]="highlightText" textStyleSize="m"></sirius-text-html>
            }
        </div>
        <div class="sir-highlight-items-container">
            @for (item of highlightedItems; track $index) {
                <div class="sir-highlight-item">
                    <sirius-highlighted-item
                        [label]="item.label"
                        [value]="item.value"
                        [icon]="item.icon.icon"></sirius-highlighted-item>
                </div>
            }
        </div>
    </div>
</sirius-grid>
